"use strict";
window.up.compiler('.js-alert_if_active_subscription_guests', function (el) {
    const element = el;
    function preventWhenGuests(e) {
        const activeGuestsCountString = element.dataset.activeGuestsCount;
        if (activeGuestsCountString) {
            const activeGuestsCount = parseInt(activeGuestsCountString, 10);
            const activeGuestsAlert = element.dataset.activeGuestsAlert;
            if (!element.checked && activeGuestsCount > 0) {
                alert(activeGuestsAlert);
                e.preventDefault();
                return false;
            }
        }
    }
    element.addEventListener('click', preventWhenGuests);
});
